import AppModal from '@components/AppModal';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useDeleteGiftCoupon from '../../hooks/useDeleteGiftCoupon';

interface Params {
    giftCouponId: string;
}

declare module '@stackflow/config' {
    interface Register {
        DeleteGiftModal: Params;
    }
}

const DeleteGiftModal: ActivityComponentType<'DeleteGiftModal'> = ({ params }) => {
    const { t } = useTranslation('gift');
    const { handleDelete, isPending } = useDeleteGiftCoupon(params.giftCouponId);

    return (
        <AppModal title={t('giftReceived.delete.confirmTitle')}
            deny={t('giftReceived.delete.cancel')}
            confirm={t('giftReceived.delete.confirm')}
            onConfirm={handleDelete}
            confirmDisabled={isPending}
            denyDisabled={isPending}
            disableOutside={isPending} >
            <Text size='title' align='center' multiline>
                {t('giftReceived.delete.confirmDescription')}
            </Text>
            <Text size='body-long' align='center' color={colors.gray6} multiline>
                {t('giftReceived.delete.notice')}
            </Text>
        </AppModal>
    );
};

export default DeleteGiftModal;
